import { RecommendSearchOptions } from '@api-client/src/api/types';
import { useSearchFactory } from '@vue-storefront/core';
import { mapToSearchResponse } from '../helpers/mapToSearchResponse';

const useRecommendSearch = useSearchFactory<
  ReturnType<typeof mapToSearchResponse>,
  RecommendSearchOptions
>({
  search: async (context, params) => {
    const indexName = 'shopify_products';
    const request = { indexName, ...params, threshold: params.threshold || 50 };

    const result = await context.$search.api.recommendSearch([request]);
    return mapToSearchResponse(result);
  },
});

export default useRecommendSearch;
